<template>
    <b-container fluid>
        <List :items="roles" :fields="fields" :permisos="permisos"/>  
    </b-container>
</template>

<script>
    import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
    import List from '@/components/admin/rolesList'
    import {mapActions,mapState} from 'vuex'
    export default {
        components:{
           List
        },     
        mixins : [validateMixin],
        data() {
            return {
                rol: {
                    nombre:   '',
                },
                reset:false,
                options: [
                  {value:1, text:'Admin'},
                  {value:2, text:'Vendedor'},
                  {value:3, text:'Ingenieria'},
                  {value:4, text:'Preprensa'},
                  {value:5, text:'Bitacora'}
                ],
                
                fields:[
                     {key:'description',label:'Nombre',sortable:true},
                     {key:'permiso', label:'Permisos'},
                     {key:'acciones',label:'Acciones'},
                ]
            }
        },        
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('admin',['isOk']),
            ...mapState('roles',['roles']),
            ...mapState('permiso',['permisos'])
        },
        methods:{
            ...mapActions({
                _fetchRoles:'roles/fetchRoles',
                _fetchPermisos:'permiso/fetchPermisos'
                
            }),
            init(){
                this._fetchRoles()
                this._fetchPermisos()
            },
            /**
             *  metodo que limpia campos y errores.
             */
            onReset(){
                this.clearForm()
                this.clearErrors()
            },
            /**
             * metodo que limpia los campos
             */
            clearForm(){
                Object.assign(this.$data, this.$options.data.apply(this))
            },
            /*
             * metodo que limpia los errores 
             */
            clearErrors(){
                this.reset = true
                this.$validator.reset()
            },
           
            

        }

        
        
    }
</script>

<style lang="scss" scoped>

</style>